<template>
  <div>
    <el-header class="header">
      <div class="header-content">
        <!-- 左侧公司名称和登录 -->
        <div class="header-left">
          <div class="header_img" style="cursor: pointer" @click="goHome">
            <img :src="loginImage" alt="亿知知识库" />
          </div>
          <div class="login-text">
            <div>国家知识资源服务平台亿知分平台</div>
          </div>
        </div>

        <!-- 右侧搜索框和登录选项 -->
        <div class="header-right">
          <el-input
            v-model="searchText"
            :placeholder="placeholderText"
            class="search-input"
            clearable
            @keyup.enter="handleSearch"
            style="width: 300px"
            v-if="route.path != '/knowledge'"
          > 
            <template #suffix>
              <el-icon class="search-icon" @click="handleSearch">
                <Search />
              </el-icon>
            </template>
          </el-input>
          <div
            style="
              font-weight: 400;
              font-size: 12px;
              text-align: left;
              color: #999999;
            "
          >
            当前IP：{{ ipdata }}
            <span v-if="!newisLoggedIn"> &nbsp; 当前IP不在范围内</span>
          </div>
          <div v-if="newisLoggedIn" style="display: flex">
            <el-dropdown>
              <span
                class="el-dropdown-link"
                @mouseenter="isHovering = true"
                @mouseleave="isHovering = false"
                style="font-size: 12px"
              >
                <span style="font-size: 12px">欢迎 &nbsp</span>
                {{ newuserName }}
                <el-icon
                  class="el-icon--right"
                  :class="{ 'rotate-180': isHovering }"
                >
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click.stop="gotoOrder"
                    >知识库列表</el-dropdown-item
                  >
                  <el-dropdown-item @click.stop="logout"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <el-button
            v-else
            type="text"
            class="el-dropdown-link"
            @click="goLoginPage"
            >请登录</el-button
          >
          <el-button type="text" class="login-button" @click="gotoAdmin"
            >出版社登录</el-button
          >
        </div>
      </div>
    </el-header>
    <div class="headernav">
      <div class="headernavlist">
        <!-- 直接列出所有导航项，不再使用v-for循环 -->
        <div
          class="navitem"
          :class="{
            active: route.path === '/',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/'}">
            <span class="nav-text">首页</span>
          </RouterLink>
        </div>
                                <div
          class="navitem"
          :class="{
            active: false,
            'has-dropdown': false,
          }"
          @click="scrollToSection('knowledge-category')"
        >
          <span class="nav-text">知识库中心</span>
        </div>
                <div
          class="navitem"
          :class="{
            active: route.path === '/NewLicationArea',
            'has-dropdown': false,
          }"
          @click="scrollToSection('application-area')"
        >
          <span class="nav-text">应用领域</span>
        </div>
          <!-- <span
            @mouseenter="handleMouseEnter({ cid: 'cidyyly' }, 1)"
            @mouseleave="handleMouseLeave"
            class="nav-text"
          >
            应用领域
            <el-icon
              class="dropdown-arrow"
              :class="{ 'arrow-up': showDropdown && dropdownIndex === 1 }"
            >
              <ArrowDown />
            </el-icon>
          </span> -->

          <!-- <div
            class="dropdown-menu"
            v-if="showDropdown && dropdownIndex === 1"
            @mouseenter="handleMouseEnter({ cid: 'cidyyly' }, 1)"
            @mouseleave="handleMouseLeave"
            ref="dropdownRef"
          >
            <div
              @mouseenter="handleMouseeEnter"
              @mouseleave="handleMouseLeaveEnter"
              class="dropdown-item"
              @click="handleSubSelect(0, '政府部门')"
            >
              政府部门
            </div>
            <div
              @mouseenter="handleMouseeEnter"
              @mouseleave="handleMouseLeaveEnter"
              class="dropdown-item"
              @click="handleSubSelect(1, '科研单位')"
            >
              科研单位
            </div>
            <div
              @mouseenter="handleMouseeEnter"
              @mouseleave="handleMouseLeaveEnter"
              class="dropdown-item"
              @click="handleSubSelect(2, '公共图书馆')"
            >
              公共图书馆
            </div>
            <div
              @mouseenter="handleMouseeEnter"
              @mouseleave="handleMouseLeaveEnter"
              class="dropdown-item"
              @click="handleSubSelect(3, '高校图书馆')"
            >
              高校图书馆
            </div>
                    </div> -->
        <!-- <div
          class="navitem"
          :class="{
            active: route.path === '/agency',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/agency'}">
            <span class="nav-text">区域销售</span>
          </RouterLink>
        </div> -->

        <!-- <div
          class="navitem"
          :class="{
            active: route.path === '/cooperation',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/cooperation'}">
            <span class="nav-text">资源合作</span>
          </RouterLink>
        </div> -->
<!-- 
        <div
          class="navitem"
          :class="{
            active: route.path === '/solution',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/solution'}">
            <span class="nav-text">解决方案</span>
          </RouterLink>
        </div> -->
<!-- 
        <div
          class="navitem"
          :class="{
            active: route.path === '/hydtinfolist',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/hydtinfolist'}">
            <span class="nav-text">动态要闻</span>
          </RouterLink>
        </div> -->
        <div
          class="navitem"
          :class="{ 'has-dropdown': false }"
          @click="scrollToSection('digital-library')"
        >
          <span class="nav-text">数字图书馆</span>
        </div>
        <div
          class="navitem"
          :class="{ 'has-dropdown': false }"
          @click="scrollToSection('premium-knowledge')"
        >
          <span class="nav-text">精品知识库</span>
        </div>
        <div
          class="navitem"
          :class="{ 'has-dropdown': false }"
          @click="scrollToSection('local-database')"
        >
          <span class="nav-text">地方数据库</span>
        </div>
        <div
          class="navitem"
          :class="{ 'has-dropdown': false }"
          @click="handleOpenBook"
        >
          <span class="nav-text">电子书</span>
        </div>
            <div
          class="navitem"
          @click="handleszjc"
          :class="{
            'has-dropdown': false,
          }"
        >
          <div class="nav-text">
            <span class="nav-text">数字教材</span>
          </div>
        </div>
        <div
          v-if="ischeck_login"
          class="navitem"
          :class="{
            active: route.path === '/PurchasedKnowledge',
            'has-dropdown': false,
          }"
        >
          <RouterLink class="nav-text" :to="{path:'/PurchasedKnowledge'}">
            <span class="nav-text">已购/试用</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from "vue";
import loginImg from "@/assets/headerimage/newheaderlog.png";
import { Search } from "@element-plus/icons-vue";
import { useUserStore } from "@/views/stores/order";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { PostLoginToken } from "@/api/index.js";
import { ArrowDown } from "@element-plus/icons-vue";
import bus from "@/mitt/bus.js";
import { Cookie } from "@/utils/Cookie";
const emit = defineEmits(["custom-event"]);
const isHovering = ref(false);
const newisLoggedIn = ref(false);
const newuserName = ref("");
const activeIndex = ref("cidsy");
const ipdata = ref("暂无");
const showDropdown = ref(false);
const dropdownIndex = ref(null);
const dropdownRef = ref(null);
const ischeck_login = ref(false);

const props = defineProps({
  placeholderText: {
    type: String,
    default: "请输入搜索内容",
  },
  userName: {
    type: String,
    default: "测试机构",
  },
});

const searchText = ref("");
const loginImage = ref(loginImg);
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const getcheck_ip = async () => {
  const res = await PostLoginToken();  
    ipdata.value = res.info.ip;
  if (res.info && res.info.result == "SUCCESSED") {
      Cookie.set("token", JSON.stringify(res.info.token));
      const checkIPStats = JSON.parse(sessionStorage.getItem("checkIP_login") || "false");
    if (!checkIPStats) {
    sessionStorage.setItem("checkIP_login", JSON.stringify(true));
      router.push("PurchasedKnowledge");
      ischeck_login.value = true;
    } else {
      ischeck_login.value = true;
    }
  } else {
    ischeck_login.value = false;
  }
};

watch(
  () => props.userName,
  (newVal) => {
    if (newVal) {
      newisLoggedIn.value = true;
      newuserName.value = newVal;
    } else {
      newisLoggedIn.value = false;
    }
  }
);

const isLoggedIn = computed(() => {
  return userStore.isLoggedIn || !!JSON.parse(Cookie.get("token")) || "";
});

watch(isLoggedIn, (newValue) => {
  bus.emit("loginStatusChanged", newValue);
});

let closeTimer = null;

const handleMouseEnter = (item, index) => {
  if (closeTimer) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  showDropdown.value = true;
  if (item.cid === "cidyyly") {
    // activeIndex.value = 'cidyyly';
    dropdownIndex.value = index;
  }
};
const handleMouseeEnter = () => {
  if (closeTimer) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }
  showDropdown.value = true;
};
const handleMouseLeaveEnter = () => {
  showDropdown.value = false;
  activeIndex.value = "";
};

const handleMouseLeave = () => {
  closeTimer = setTimeout(() => {
    showDropdown.value = false;
  }, 300);
};
const goHome = () => {
  router.push("/");
};

const gotoOrder = () => {
  if (!isLoggedIn) {
    ElMessage.warning("请先登录");
    router.push("/login");
    return;
  }
  router.push("/OrderCompletPage");
};

const logout = () => {
  try {
    userStore.clearUserInfo();
    emit("custom-event", "这是来自子组件的数据");
    newisLoggedIn.value = false;
    ischeck_login.value = false;
    router.push("/");
  } catch (e) {
    console.error("退出登录出错:", e);
    ElMessage.error("退出登录失败");
  }
};

const handleSubSelect = (index, subItem) => {
  if (index === 0) {
    router.push({
      path: "DatabaseDetails",
      query: { id2: "396", name: subItem },
    });
  } else if (index === 1) {
    router.push({
      path: "DatabaseDetails",
      query: { id2: "397", name: subItem },
    });
  } else if (index === 2) {
    router.push({
      path: "DatabaseDetails",
      query: { id2: "398", name: subItem },
    });
  } else if (index === 3) {
    router.push({
      path: "DatabaseDetails",
      query: { id2: "399", name: subItem },
    });
  }
  localStorage.setItem("lastSelectTime", Date.now().toString());
  showDropdown.value = false;
};

const handleSearch = () => {
  const keyword = searchText.value.trim();
  if (!keyword) {
    ElMessage.warning("请输入搜索内容");
    if (route.name === "knowledge") {
      const query = { ...route.query };
      delete query.keyword;
      router.push({ name: "knowledge", query });
    }
    return;
  }

  if (route.name === "knowledge") {
    bus.emit("indexKeyWord", { message: "首页检索框", data: keyword });
  } else {
    router.push({ name: "knowledge", query: { keyword } });
  }
};

const goLoginPage = () => {
   const from = router.currentRoute.value.fullPath;
  router.push({
    path: '/login',
    query: { from }
  });
};

const gotoAdmin = () => {
  window.open("http://www.ckbop.com:8000");
};

onMounted(async () => {
  await getcheck_ip();
  try {
    if (!userStore.userInfo) {
      userStore.userInfo = {};
    }

    const storedUser = JSON.parse(Cookie.get("userInfo")) || null;
    if (storedUser) {
      userStore.userInfo = JSON.parse(storedUser) || {};
    }
  } catch (e) {
    userStore.userInfo = {};
  }
});

const newactiveIndex = ref("1");
const handlenewSelect = (key, keyPath) => {
  console.log(key, keyPath);
};

// onClickOutside(dropdownRef, () => {
//   showDropdown.value = false;
// });
const handleszjc =() =>{
  // window.open("：szjc.ckbop.com/study");
    window.open('http://szjc.ckbop.com/study/#/', "_blank");
}

const handleOpenBook = () => {
  window.open('http://book.ckbop.com/', '_blank');
}

// 锚点滚动：如果在首页则直接滚动，否则先跳转到首页再滚动
const scrollToSection = (id) => {
  const offset = 150; // 固定头部高度偏移量
  if (route.path === '/') {
    // 已在首页，直接滚动（带偏移）
    nextTick(() => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  } else {
    // 不在首页，先导航到首页，然后滚动
    router.push({ path: '/', query: { scrollTo: id } });
  }
};
</script>

<style scoped>
/* 保持原有样式不变 */
.header {
  padding: 0;
  height: auto;
  width: 100%;
  background-color: transparent;
  background: #fff;
}

.header_img {
  width: 143px;
  height: 86px;
}

.header_img > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.header-content {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  padding-top: 20px;
  height: 86px;
}

.header-left {
  display: flex;
  align-items: center;
  margin-top: -10px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.login-text {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 18.48px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  vertical-align: top;
  width: 195px;
  padding: 5px 0 10px 10px;
}

.el-menu-demo {
  border-bottom: none;
  background: #1c6bfb;
}

.el-menu-item {
  background-color: transparent !important;
}

.el-menu-item.is-active,
.el-menu-item:hover {
  color: #fff !important;
}

.el-menu-item:hover {
  background-color: transparent !important;
}

.login-button {
  margin-left: 10px;
}

.search-input {
  width: 461px;
  height: 40px;
}

.search-icon {
  cursor: pointer;
  color: #1c6bfb;
  transition: color 0.3s;
}

.search-icon:hover {
  color: #409eff;
}

.el-dropdown-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0 12px;
}

.arrow-icon {
  margin-left: 6px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
}

.rotate-180 {
  transform: rotate(180deg);
}

:deep(.el-dropdown-menu__item) {
  padding: 8px 20px;
  font-size: 14px;
}

.el-dropdown .el-dropdown-link:focus,
.el-dropdown .el-dropdown-link:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.el-menu--horizontal > .el-menu-item {
  margin-left: 30px;
}

.el-menu--horizontal > .el-menu-item.is-active {
}

.headernav {
  width: 100%;
  height: 50px;
  background: #1c6bfb;
  display: flex;
  justify-content: center;
}

.headernavlist {
  width: 1400px;
  display: flex;
  /* justify-content: space-around; */
}

.navitem {
  position: relative;
  font-weight: 400;
  color: #ffffff;
  width: 120px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  /* border-right: 1px solid rgba(255, 255, 255, 0.1); */
  cursor: pointer;
  transition: all 0.3s ease;
}
.navitem  a{
  color: #fff;
  text-decoration: none;
}
.navitem:hover a{
  color: #f97619;
  background-color: rgba(255, 255, 255, 0.1);
}

.navitem.active {
  background-color: #f97619;
  color: white;
}

.navitem.active:hover a{
  color: #fff;
  background-color: #f97619;
}

.navitem:last-child {
  border-right: none;
}

.has-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.dropdown-arrow {
  margin-left: 5px;
  transition: transform 0.3s ease;
  font-size: 12px;
}

.arrow-up {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 63px;
  left: 68%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100px;
  height: 167px;
  z-index: 100;
}

.dropdown-menu::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 48%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  z-index: 101;
}

.dropdown-menu::after {
  content: "";
  position: absolute;
  top: -8px;
  left: 48%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #eee;
  z-index: 99;
}

.dropdown-item {
  height: 39px;
  text-align: left;
  padding-left: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
  color: #1c6bfb;
}
</style>
